import React, {useState, useRef, useEffect} from "react";
import axios from "axios";
import {ApiUrl} from "../../auth/authMethods";
import Textarea from "@mui/joy/Textarea";
import FileInput from "../FileInput/FileInput";
import {Button} from "react-bootstrap";

export default function InputsdLogBook({setLoadItens, setShowInputs, url}) {

    const [anotacao, setAnotacao] = useState('')
    const [anexos, setAnexos] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const fileInputRef = useRef(null)

    useEffect(() => {
        // quando o formulário abre
        fileInputRef.current?.focus()
    }, [])

    const postItem = (e) => {

        e.preventDefault()


        const formData = new FormData();
        formData.append('anotacao', anotacao);
        for (let file of anexos) {
            formData.append('files', file);
        }

        setIsLoading(true)
        axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
            .then(() => {
                setLoadItens(true)
                setShowInputs(false)
            })
            .catch(() => {
            }).finally(() => setIsLoading(false))
    }

    return <>
        <form action={postItem} style={{textAlign: 'center'}}>
            <h4>Adicionar Item</h4>

            <Textarea
                value={anotacao}
                onChange={(e) => setAnotacao(e.target.value)}
                required
                placeholder='Descrição'
                size="lg"
                variant="outlined"
                className="mt-3 mb-3"
                minRows={3}
                sx={{width: '70%', marginLeft: '15%'}}
            />

            <FileInput
                ref={fileInputRef}
                selectedFile={anexos}
                setSelectedFile={setAnexos}
                multiple
            />


            <div className='text-center'>
                <Button
                    onClick={postItem}
                    disabled={isLoading || !anotacao}
                    className={isLoading ? "btn btn-secondary" : ""}
                >
                    {isLoading ? (<>
                          <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                          ></span>
                        &nbsp;Aguarde...
                    </>) : (<>Adicionar</>)}
                </Button>
            </div>
        </form>
    </>
}